module.exports = __webpack_public_path__ + "img/98.8a057623.jpg";